// styles
import classnames from 'classnames/bind';
import T from 'prop-types';
import React from 'react';

import styles from './Button.module.scss';

const cx = classnames.bind(styles);

const VARIANTS = ['outlined', 'link'];

const Button = ({ label = '', variant, onClick, submit, disabled, className }) => (
  <button
    className={cx('button', className, { [styles.disabled]: disabled }, { [`button--${variant}`]: !!variant })}
    type={submit ? 'submit' : 'button'}
    disabled={disabled}
    onClick={onClick}
  >
    {label}
  </button>
);

Button.propTypes = {
  label: T.string.isRequired,
  variant: T.oneOf(VARIANTS),
  onClick: T.func,
  submit: T.bool,
  disabled: T.bool,
  className: T.string,
};

export default Button;
